import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-user-menu-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-menu-item.component.html',
  styleUrls: ['./user-menu-item.component.scss']
})
export class UserMenuItemComponent implements OnInit {

  auth = inject(AuthService)
  user: any

  ngOnInit() {
    this.auth.user$.subscribe((response) => {
      this.user = response
    })
  }
}
